import ReactDOM from 'react-dom/client'
import thunk from 'redux-thunk'
import { createStore, compose, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { rooteReducer } from './redux/reducer'
import App from './App'
//import 'normalize.css'
import './assets/styles/styles.scss'
import { useState } from 'react'

await import('./modules/global')
await import('./modules/callpyGlobal')
await import('./modules/$jcallpy')
await import('./modules/ccallpy')
await import('./modules/ccookie')
await import('./modules/cloader')
await import('./modules/clogger')
await import('./modules/cmessage')
await import('./modules/cbridge')
await import('./modules/dklab_realplexor')
await import('./modules/capi')
await import('./modules/cstorage')
await import('./modules/cuser')
await import('./modules/cflash')
await import('./modules/ccontrol')
await import('./modules/cactivity')
await import('./modules/cautos')
// await import('./modules/cmanager')
await import('./modules/cuser_chat')
await import('./modules/view_chat')

const store = createStore(rooteReducer, compose(applyMiddleware(thunk),window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()))



const CallpyChat = (opt={}) => {
  const label = opt?.label??false
  const open = opt?.open??true
  const [chat, setChat] = useState()

  class APPLICATION  {
    constructor () {
      this.storageName = 'CallpyApp'
      this.globalTimestamp = null
      this.storageData
      //this.isInitialization = true
  
      this.CONNECT_MODULES()
  
      this.INIT()
    }
  
    INIT ()  {
      const currenTime = new Date().getTime()
      if(this.globalTimestamp) {
        const cashTime = this.globalTimestamp*1000
        console.log('cashTime', cashTime)
      } else {
        this.globalTimestamp = currenTime
      }
  
      const storage = this.STORAGE().get()
      let response
      if(this.storageName) {
        response = <Provider store={store}><App/></Provider>
      }
    }
    STORAGE () {
      const storageName = this.storageName
  
      const get = () => {
        let storageData = JSON.parse(localStorage.getItem(storageName))??null
        if(storageData) {
          this.storageData = storageData
        } else {
          storageData = {
            //class: this,
            styles: {
              timestamp: Date.now(),
              data:''
            },
            scripts: {
              timestamp: Date.now(),
              data:''
            },
            store: {}
          }
          this.storageData = storageData
          localStorage.setItem(storageName, JSON.stringify(storageData))
        }
        return storageData
      }
  
      return {
        get
      }
    }
  }

  useEffect(() => {
    const runApp = () => {
      let isReady = false
      let timerId = null
    
      timerId = setInterval(() => {
        isReady = window?.m_callpy?.initialize_data
        if(isReady) {
          clearTimeout(timerId)
          if(!isReady?.history) {
            window.m_callpy.initialize_data.history = []
          }
          new APPLICATION
        }
      }, 1000)
    }
    
    let response
    if (document.readyState !== 'loading') {
      response = window.m_callpy.init()
      runApp()
      setChat(response)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        console.log('doc===>ok-2')
        response = window.m_callpy.init()
        runApp()
        setChat(response)
      })
    }
  }, [])
  return chat
}
export default CallpyChat

